import React, { memo } from 'react';

import { useThemeGetter } from '@hooks';

import {
  StackText,
  StackItemContainer,
  StackItemTextBlock,
  StackItemBorderContainer,
} from './StackItem.styled';

import { StackItemProps } from './StackItem.types';

export const StackItem = memo(({ text, length, active }: StackItemProps) => {
  const {
    theme: { TitleReverse, BackgroundReverse, ElementShadow, Main },
  } = useThemeGetter();

  return (
    <StackItemContainer>
      <StackItemBorderContainer
        length={length}
        shadow={ElementShadow}
        color={active ? Main : BackgroundReverse}
      >
        <StackItemTextBlock bgColor={active ? Main : BackgroundReverse}>
          <StackText color={TitleReverse} active={active}>
            {text}
          </StackText>
        </StackItemTextBlock>
      </StackItemBorderContainer>
    </StackItemContainer>
  );
});
